import React from "react";

export default function SafeguardingGroup(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Child Safeguarding & Protection Group at Slum Soccer
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-4">
            A Child Safeguarding & Protection Group (CSPG) headed by Mr. Pankaj
            Mahajan, Child Protection Officer (CPO) of SS has been constituted
            by the CEO, SS to assist him in relevant matters including providing
            support to children, and staff during and following an incident,
            allegation or complaint.
          </span>
          <span className="text-gray-700 block mb-1">
            The Child Safeguarding & Protection Group comprises the following:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">1.</span>
              <span className="text-gray-700">
                Mr. Pankaj Mahajan, CPO and Chairperson of CSPG
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">2.</span>
              <span className="text-gray-700">
                Ms. Swati Telrandhe, Accounts Head, Slum Soccer, Member CSPG
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">3.</span>
              <span className="text-gray-700">
                Ms. Shiba Markas, Program Manager, Slum Soccer, Member CSPG
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">4.</span>
              <span className="text-gray-700">
                Mr. Devang Chhaya, Program Co-ordinator, Slum Soccer, Member
                CSPG
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">5.</span>
              <span className="text-gray-700">
                Mr.Mustak Pathan,District Woman Child Development,
                Nagpur(Independent Member CSPG)
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Wherever required, the CEO may also seek the advice of CWC on
            further course of action required to be taken by Slum Soccer
            regarding the alleged abuser, the abused child and the parents of
            the abused child.
          </span>
        </div>
      </div>
    </div>
  );
}
